import PulseCryptoJSCore from 'crypto-js/core';
import PulseCryptoAes from 'crypto-js/aes';
import PulseCryptoEncUTF8 from 'crypto-js/enc-utf8';
import PulseCryptoBas64 from 'crypto-js/enc-base64';
import PulseCryptoHmacSHA256 from 'crypto-js/hmac-sha256';

export class PulseHmac {

    constructor(authId, secret) {
        this._authId = authId;
        this._secret = secret;
    }

    getHashedURL(method, url, params, data, date = new Date()) {

        // Ensure method is upper case
        method = method.toUpperCase();

        const timestamp = Math.floor(date.getTime() /1000);

        const queryStrings = [];

        const keys = Object.keys(params);
        keys.sort(function (a, b) {
            return a.toUpperCase().localeCompare(b.toUpperCase());
        });

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // We don't add keys with a null or undefined value to keep in sync with how Axiom builds a query string
            if (params.hasOwnProperty(key) && params[key] != null) {
                queryStrings.push(key + '\n' + params[key]);
            }
        }

        // Ensure there is a leading slash because Axios will add it in if it's missing, but it'll break HMAC if it's missing.
        const hmacUrl = url.startsWith('/') ? url : '/' + url;

        let dataToHash = method + '\n'
        + hmacUrl + '\n'
        + (data || '') + '\n'
        + timestamp;

        if (queryStrings.length > 0) {
            dataToHash += '\n' + queryStrings.join('\n');
        }

        //// Construct hash
        const hmac = PulseCryptoJSCore.HmacSHA256(dataToHash, this._secret).toString(PulseCryptoJSCore.enc.Base64);

        const returnObj = {
            hmac,
            authid: this._authId,
            timestamp
        };

        return returnObj;
    };
}
